import * as Backbone from "backbone";
import { autoinject } from "aurelia-dependency-injection";
import { UrlHelper } from "../shared/helpers/url-helpers";
import { MasterView } from "../shared/views/master-view";
import { FullScreenThinker } from "../shared/plugins/full-screen-thinker";
import { ErrorMessage } from "../shared/views/error-message";
import {Container} from "aurelia-dependency-injection";
import {MobileHelper} from "../shared/helpers/mobile-helper";
import { AuthService } from "./auth-service";

require("../authentication/user-form.less");

@autoinject
export class AuthModule extends Backbone.Model {

    constructor(
        private appEvents: Backbone.Events,
        private masterView: MasterView,
        private errorMessage: ErrorMessage,
        private authService: AuthService) {
        super();
    }

    public async showSignIn(options?: any) {
        options = options || {};
        this.masterView.showThinker("Redirecting to sign in...");
        await this.authService.startAuthentication(options.successUrl || "", options.override);
    }

    public async wayflessSignIn(entityId: string, returnUrl?: string) {
        this.masterView.showThinker("Redirecting to your institution...");
        await this.authService.wayflessSignIn(entityId, returnUrl);
    }

    public async activeDirectoryDirectSignIn(returnUrl?: string) {
        this.masterView.showThinker("Connecting to Active Directory...");
        await this.authService.activeDirectoryDirectSignIn(returnUrl);
    }

    public async urlSignin(username: string, password: string) {
        this.masterView.showThinker("Signing in...");
        await this.authService.signInWithUrlCredentials(username, password);
    }

    public async signOut(options?: any) {
        if (this.authService.AppUser.IsAuthenticated) {
            this.masterView.showThinker("Signing out...");
            await this.authService.signOut();
        } else {
            Backbone.history.navigate("my-justis");
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/authentication/auth-module.ts